import Model from "../classes/Model";
import Api from "../classes/api/Client";
import ValidationError from "../classes/ValidationError";
import moment from "moment";
import ClientSubscription from "./ClientSubscription";
import ClientCard from "./ClientCard";
import Cashflow from "./Cashflow";
import Debt from "./Debt";
import ClientStatus from "./ClientStatus";

export default class Client extends Model {

    static get SOURCE_CALL() { return 1; }
    static get SOURCE_DIRECT() { return 2; }
    static get SOURCE_SEARCH() { return 3; }
    static get SOURCE_RECOMMENDATION() { return 4; }
    static get SOURCE_WALK() { return 5; }
    static get SOURCE_OTHER() { return 6; }
    static get SOURCE_INSTAGRAM() { return 9; }
    static get SOURCE_YANDEX_UTM() { return 7; }
    static get SOURCE_GOOGLE_UTM() { return 8; }

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }

    get responsibleId() {
        return this._responsibleId;
    }
    set responsibleId(value) {
        this._responsibleId = value;
    }

    get managerId() {
        return this._managerId;
    }
    set managerId(value) {
        this._managerId = value;
    }

    get firstName() {
        return this._firstName;
    }
    set firstName(value) {
        this._firstName = value;
    }
    get lastName() {
        return this._lastName;
    }
    set lastName(value) {
        this._lastName = value;
    }
    get fullName() {
        let pieces = [];
        if (this.firstName) {
            pieces.push(this.firstName);
        }
        if (this.lastName) {
            pieces.push(this.lastName);
        }
        return pieces.join(' ');
    }

    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
    }

    get sourceName() {
        let source = Client.getSources().find(element => element.id === this.source);
        return source ? source.name : '';
    }

    get email() {
        return this._email;
    }
    set email(value) {
        this._email = value;
    }

    get phone() {
        return this._phone;
    }
    set phone(value) {
        this._phone = value;
    }
    get birthday() {

        return this._birthday ? this._birthday : '';
    }
    set birthday(value) {
        this._birthday = value;
    }
    get todayBirthday() {
        if (!this._birthday) {
            return false;
        }
        const birthday = moment(this._birthday, 'YYYY-MM-DD').format('MM-DD');
        const current = moment().format('MM-DD');

        return birthday === current;
    }
    set comment(value) {
        this._comment = value;
    }
    get comment() {
        return this._comment;
    }
    set smsNotification(value) {
        this._smsNotification = value;
    }
    get smsNotification() {
        return this._smsNotification;
    }
    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }
    get subscriptions() {
        return this._subscriptions;
    }
    set subscriptions(value) {
        this._subscriptions = value;
    }
    get cards() {
        return this._cards;
    }
    set cards(value) {
        this._cards = value;
    }
    get debts() {
        return this._debts;
    }
    set debts(value) {
        this._debts = value;
    }
    get sale() {
        return this._sale;
    }
    set sale(value) {
        this._sale = value;
    }
    get sales() {
        return this._sales;
    }
    set sales(value) {
        this._sales = value;
    }
    get counters() {
        return this._counters;
    }
    set counters(value) {
        this._counters = value;
    }
    get lastTest() {
        return this._lastTest;
    }
    set lastTest(value) {
        this._lastTest = value;
    }
    get status() {
        return this._status;
    }
    set status(value) {
        this._status = value;
    }
    get subStatus() {
        return this._subStatus;
    }
    set subStatus(value) {
        this._subStatus = value;
    }
    get isArchive() {
        return this._isArchive;
    }
    set isArchive(value) {
        this._isArchive = value;
    }
    get isCorp() {
        return this._isCorp;
    }
    set isCorp(value) {
        this._isCorp = value;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            responsible_id: this.responsibleId,
            manager_id: this.managerId,
            first_name: this.firstName,
            last_name: this.lastName,
            source: this.source,
            email: this.email,
            phone: this.phone,
            birthday: this.birthday,
            comment: this.comment,
            is_archive: this.isArchive,
            is_corp: this.isCorp,
            sms_notification: this.smsNotification,
        };
    }

    static toResponse(data) {
        let subscriptions = [];
        if (undefined !== data.subscriptions && data.subscriptions) {
            for (let subscription of data.subscriptions) {
                subscriptions.push(new ClientSubscription(ClientSubscription.toResponse(subscription)));
            }
        }
        let cards = [];
        if (undefined !== data.cards && data.cards) {
            for (let card of data.cards) {
                cards.push(new ClientCard(ClientCard.toResponse(card)));
            }
        }
        let debts = [];
        if (undefined !== data.debts && data.debts) {
            for (let debt of data.debts) {
                debts.push(new Debt(Debt.toResponse(debt)));
            }
        }
        let sales = [];
        if (undefined !== data.sales && data.sales) {
            for (let sale of data.sales) {
                sales.push(new Cashflow(Cashflow.toResponse(sale)));
            }
        }
        return {
            id: data.id,
            responsibleId: data.responsible_id,
            managerId: data.manager_id,
            firstName: data.first_name,
            lastName: data.last_name,
            source: data.source,
            email: data.email,
            phone: data.phone,
            birthday: data.birthday,
            comment: data.comment,
            status: data.status,
            subStatus: data.sub_status,
            isArchive: data.is_archive,
            isCorp: data.is_corp,
            smsNotification: data.sms_notification,
            sale: data.sale,
            subscriptions: subscriptions,
            cards: cards,
            debts: debts,
            sales: sales,
            counters: data.counters,
            lastTest: data.last_test,
            createdBy: data.created_by,
            updatedBy: data.updated_by,
            createdAt: data.created_at,
            updatedAt: data.updated_at,
        };
    }

    static getSources() {
        return [
            {id: Client.SOURCE_CALL, name: 'Звонок'},
            {id: Client.SOURCE_DIRECT, name: 'Директ'},
            {id: Client.SOURCE_SEARCH, name: 'Поиск (нашли в интернете)'},
            {id: Client.SOURCE_RECOMMENDATION, name: 'Рекомендация'},
            {id: Client.SOURCE_INSTAGRAM, name: 'Инстаграм'},
            {id: Client.SOURCE_YANDEX_UTM, name: 'Yandex (UTM)'},
            {id: Client.SOURCE_GOOGLE_UTM, name: 'Google (UTM)'},
            {id: Client.SOURCE_INSTAGRAM, name: 'Инстаграм'},
            {id: Client.SOURCE_WALK, name: 'Мимо проходил'},
            {id: Client.SOURCE_OTHER, name: 'Прочее (оставить комментарий)'},
        ];
    }

    static getList(page = 1, perPage = 10, filter = {}, sort = undefined) {
        return Api.getList(page, perPage, filter, sort).then((response) => {
            let data = [];
            for (let client of response.data) {
                data.push(new this(this.toResponse(client)));
            }
            return {data, headers: response.headers};
        });
    }

    static find(query) {
        return Api.find(query).then((response) => {
            let data = [];
            for (let client of response.data) {
                data.push(new this(this.toResponse(client)));
            }
            return data;
        });
    }

    static get(id) {
        return Api.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }

    getStatusName() {
        if (!this.status) {
            return '';
        }
        const statuses = ClientStatus.getStatuses();
        let status = statuses.find(row => row.id === this.status);

        return status ? status.name : '';
    }

    getSubStatusName() {
        if (!this.subStatus) {
            return '';
        }
        const statuses = ClientStatus.getSubStatuses();
        let status = statuses.find(row => row.id === this.subStatus);

        return status ? status.name : '';
    }


    static getSale(id) {
        return Api.getSale(id).then(({data}) => {

            return data.sale;
        });
    }

    add() {
        let request = this.toRequest();
        return Api.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new Client(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return Api.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    setResponsible() {
        if (!this.id) {
            throw new Error('id not set');
        }
        return Api.setResponsible({id: this.id, responsible_id: this.responsibleId}).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    setManager() {
        if (!this.id) {
            throw new Error('id not set');
        }
        return Api.setManager({id: this.id, manager_id: this.managerId}).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    static setStatus(clientId, subStatus, text = '') {
        return Api.setStatus(clientId, subStatus, text).then(({data}) => {
            return data.success;
        })
    }

}
